import { Phrase } from '../types/Phrase';

export const phraseDataset: Phrase[] = [
  {
    id: 'phrase-001',
    jp: '魔法使いは動く城に住んでいる。',
    en: 'The wizard lives in a moving castle.',
    hiragana: 'まほうつかいはうごくしろにすんでいる。',
    romanji: 'mahou tsukai wa ugoku shiro ni sunde iru.',
    explanation: 'This sentence uses the verb 住んでいる (to live) and describes a moving castle.',
    sample: '魔法使いは動く城に住んでいる。 (The wizard lives in a moving castle.)',
    jp_tiles: ['魔法使いは', '動く', '城に', '住んでいる。'],
    hiragana_tiles: ['まほうつかいは', 'うごく', 'しろに', 'すんでいる。'],
    romanji_tiles: ['mahou tsukai wa', 'ugoku', 'shiro ni', 'sunde iru.'],
    en_tiles: ['The', 'wizard', 'lives', 'in', 'a', 'moving', 'castle.'],
  },
  {
    id: 'phrase-002',
    jp: '私は毎朝コーヒーを飲みます。',
    en: 'I drink coffee every morning.',
    hiragana: 'わたしはまいあさこーひーをのみます。',
    romanji: 'watashi wa mai asa koohii o nomimasu.',
    explanation: '毎朝 (every morning) and the verb 飲みます (to drink) are used here.',
    sample: '私は毎朝コーヒーを飲みます。 (I drink coffee every morning.)',
    jp_tiles: ['私は', '毎朝', 'コーヒーを', '飲みます。'],
    hiragana_tiles: ['わたしは', 'まいあさ', 'コーヒーを', 'のみます。'],
    romanji_tiles: ['watashi wa', 'mai asa', 'koohii o', 'nomimasu.'],
    en_tiles: ['I', 'drink', 'coffee', 'every', 'morning.'],
  },
  {
    id: 'phrase-003',
    jp: '猫が窓の外にいます。',
    en: 'There is a cat outside the window.',
    hiragana: 'ねこがまどのそとにいます。',
    romanji: 'neko ga mado no soto ni imasu.',
    explanation: '猫 (cat), 窓 (window), and います (to exist for animate objects) are used.',
    sample: '猫が窓の外にいます。 (There is a cat outside the window.)',
    jp_tiles: ['猫が', '窓の外に', 'います。'],
    hiragana_tiles: ['ねこが', 'まどのそとに', 'います。'],
    romanji_tiles: ['neko ga', 'mado no soto ni', 'imasu.'],
    en_tiles: ['There', 'is', 'a', 'cat', 'outside', 'the', 'window.'],
  },
  {
    id: 'phrase-004',
    jp: '今日は天気がいいです。',
    en: 'The weather is nice today.',
    hiragana: 'きょうはてんきがいいです。',
    romanji: 'kyou wa tenki ga ii desu.',
    explanation: '天気 (weather) and いい (good/nice) are used.',
    sample: '今日は天気がいいです。 (The weather is nice today.)',
    jp_tiles: ['今日は', '天気が', 'いいです。'],
    hiragana_tiles: ['きょうは', 'てんきが', 'いいです。'],
    romanji_tiles: ['kyou wa', 'tenki ga', 'ii desu.'],
    en_tiles: ['The', 'weather', 'is', 'nice', 'today.'],
  },
  {
    id: 'phrase-005',
    jp: '駅まで歩きましょう。',
    en: "Let's walk to the station.",
    hiragana: 'えきまであるきましょう。',
    romanji: 'eki made arukimashou.',
    explanation: '駅 (station), 歩きましょう (let\'s walk) are used.',
    sample: '駅まで歩きましょう。 (Let\'s walk to the station.)',
    jp_tiles: ['駅まで', '歩きましょう。'],
    hiragana_tiles: ['えきまで', 'あるきましょう。'],
    romanji_tiles: ['eki made', 'arukimashou.'],
    en_tiles: ["Let's", 'walk', 'to', 'the', 'station.'],
  },
  {
    id: 'phrase-006',
    jp: '水を一杯ください。',
    en: 'Please give me a glass of water.',
    hiragana: 'みずをいっぱいください。',
    romanji: 'mizu o ippai kudasai.',
    explanation: '水 (water), 一杯 (one glass), ください (please give) are used.',
    sample: '水を一杯ください。 (Please give me a glass of water.)',
    jp_tiles: ['水を', '一杯', 'ください。'],
    hiragana_tiles: ['みずを', 'いっぱい', 'ください。'],
    romanji_tiles: ['mizu o', 'ippai', 'kudasai.'],
    en_tiles: ['Please', 'give', 'me', 'a', 'glass', 'of', 'water.'],
  },
]; 